module.exports = __webpack_public_path__ + "static/presidents-message-c56ca9c20505a90028d05e873cce9554.jpg";